export default __webpack_public_path__ + "static/media/Chesthavashisht.c8146137.png";